module.exports = __webpack_public_path__ + "static/media/5e92fedc3338321d193dd82a_Icon (2).27e9af2b.svg";